module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_delete_light.2abd9.png";